import React, { Component } from "react";
import MainMenu from "./components/mainMenu";

import {
  Scene,
  PerspectiveCamera,
  WebGLRenderer,
  AmbientLight,
  BoxGeometry,
  MeshBasicMaterial,
  DoubleSide,
  PlaneBufferGeometry,
  Mesh,
  Vector3,
  PointLight,
  DirectionalLight,
  LoadingManager,
  TextureLoader
} from "three";

import { OBJLoader, MTLLoader, DDSLoader } from "three-addons";

//import OBJLoader from "three/examples/js/loaders/OBJLoader";

export default class SuitBuilder extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const width = this.mount.clientWidth;
    const height = this.mount.clientHeight;

    const scene = new Scene();
    const ambientlight = new AmbientLight(0xcccccc, 0.4);
    const pointLight = new PointLight(0xffffff, 0.8);
    const directionalLight = new DirectionalLight(0xffffff);
    directionalLight.position.set(30, 40, 50);
    directionalLight.intensity = 0.3;
    scene.add(directionalLight);
    const camera = new PerspectiveCamera(
      90, //FOV in degrees
      window.innerWidth / window.innerHeight, //aspect ratio
      0.1, //near clipping plane
      1000 //far clipping plane
    );
    //  camera.position.set(0, 10, -5);
    //  camera.lookAt(new Vector3(0, 10, 0));
    const renderer = new WebGLRenderer({ antialias: true });

    const geometry = new BoxGeometry(20, 20, 20);
    const material = new MeshBasicMaterial({
      color: "#433F81"
      //side: DoubleSide
      //wireframe: true
    });
    const cube = new Mesh(geometry, material);

    const geo = new PlaneBufferGeometry(2000, 2000, 2, 2);
    const mat = new MeshBasicMaterial({
      color: 0xffffff,
      //wireframe: true
      side: DoubleSide
    });
    //this works,
    cube instanceof Mesh ? console.log("isMesh") : console.log("notMesh");

    const manager = new LoadingManager();
    manager.onProgress = this.loaderProgress;

    const textureLoader = new TextureLoader(manager);
    const texture = textureLoader.load("models/UV_Grid_Sm.jpg");

    const objLoader = new OBJLoader(manager);

    camera.position.z = 250; //250;
    camera.position.y = 200;
    scene.add(ambientlight);
    camera.add(pointLight);
    scene.add(camera);

    //scene.add(cube);

    renderer.setClearColor("#444");
    renderer.setPixelRatio(window.devicePixelRatio);
    renderer.setSize(width, height);
    renderer.shadowMap.enabled = true;

    this.scene = scene;
    this.camera = camera;
    this.renderer = renderer;
    this.material = material;
    this.cube = cube;

    objLoader.load(
      //"/models/male02.obj",
      "/models/Male_resave.obj",
      object => {
        //object.castShaddow = true;
        //object.receiveShadow = true;

        console.log("OBJ", object);
        object.traverse(child => {
          console.log("CHD", child);

          if (child.isMesh) {
            console.log("found Mesh, apply texture", texture);
            //child.material.map = texture;
          } else {
            console.log("child not a mesh");
          }
        });
        object.position.y = 220; //-95;
        object.scale.multiplyScalar(40);
        console.log("adding model to scene...");
        this.model = object;
        this.scene.add(this.model);

        this.mount.appendChild(this.renderer.domElement);
        this.start();
      },
      this.onProgress,
      this.onError
    );

    const plane = new Mesh(geo, mat);
    plane.rotation.x += Math.PI / 2;
    plane.receiveShadow = true;

    scene.add(plane);

    window.addEventListener("resize", this.onWindowResize);

    //this.mount.appendChild(this.renderer.domElement);
  }

  componentWillUnmount() {
    this.stop();
    this.mount.removeChild(this.renderer.domElement);
    window.removeEventListener("resize", this.onWindowResize);
  }

  start = () => {
    if (!this.frameId) {
      this.frameId = requestAnimationFrame(this.animate);
    }
  };

  stop = () => {
    cancelAnimationFrame(this.frameId);
  };

  animate = () => {
    //this.model.rotation.x += 0.01;
    this.model.rotation.y += 0.01;

    this.renderScene();
    this.frameId = window.requestAnimationFrame(this.animate);
  };

  renderScene = () => {
    this.renderer.render(this.scene, this.camera);
  };

  loaderProgress = (item, loaded, total) => {
    console.log("loader progress:", item, loaded, total);
    if (loaded === total) this.renderScene();
  };

  onProgress = xhr => {
    if (xhr.lengthComputable) {
      var percentComplete = xhr.loaded / xhr.total * 100;
      console.log(Math.round(percentComplete, 2) + "% downloaded");
    }
  };

  onError = err => console.error(err);

  onWindowResize = event => {
    this.renderer.setSize(window.innerWidth, window.innerHeight);
    this.camera.aspect = window.innerWidth / window.innerHeight;
    this.camera.updateProjectionMatrix();
  };

  render() {
    return (
      <div>
        <MainMenu />
        <div
          style={{ width: "100vw", height: "100vh" }}
          ref={mount => {
            this.mount = mount;
          }}
        />
      </div>
    );
  }
}
